import { render, staticRenderFns } from "./HodOnboardingRejectedPage.vue?vue&type=template&id=9f9262d0&scoped=true&"
import script from "./HodOnboardingRejectedPage.vue?vue&type=script&lang=ts&"
export * from "./HodOnboardingRejectedPage.vue?vue&type=script&lang=ts&"
import style0 from "./HodOnboardingRejectedPage.vue?vue&type=style&index=0&id=9f9262d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9262d0",
  null
  
)

export default component.exports